// Consulta
import sespConsulta from './consulta';


export default {
  sespConsulta,
};
